// extracted by mini-css-extract-plugin
export default {"base":"UserRegisterError__base___14AkZ","description":"UserRegisterError__description___bJziu"};